var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocumentLegalLowHammer = function SvgDocumentLegalLowHammer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.998 22.004H5.997a2 2 0 0 1-2-2V5.996a2 2 0 0 1 2-2h11.005a2 2 0 0 1 2 2V9M17.773 16.162l3.684 3.117a1.546 1.546 0 1 1-2.142 2.219l-3.265-3.596M7.998 8.998h6.003M7.998 13h2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13.925 14.862-1.466 1.167a1.222 1.222 0 0 0-.1 1.816l1.116 1.12a1.207 1.207 0 0 0 1.8-.1l1.177-1.463c.28-.348.597-.664.946-.942l1.466-1.168a1.22 1.22 0 0 0 .1-1.815l-1.112-1.121a1.208 1.208 0 0 0-1.8.1L14.87 13.92c-.28.348-.597.664-.946.942v0Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.924 21.984h-2.001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDocumentLegalLowHammer;